<div *ngIf="tenantService.env !== 'prod'" class="cloud_console_environment_ribbon" style="background-color: rgb(220, 38, 38);">
  <p class="env_ribbon_p">Ambiente:
    <span class="font-semibold">{{tenantService.env}}</span>
  </p>
</div>
<router-outlet></router-outlet>